// extracted by mini-css-extract-plugin
module.exports = {"content":"DuplicateWorkflowDialog_content_Asx89","footer":"DuplicateWorkflowDialog_footer_2r30D"};